"use strict";
// (C) 2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.BarChartDescriptor = void 0;
var tslib_1 = require("tslib");
var PluggableBarChart_1 = require("./PluggableBarChart");
var BaseChartDescriptor_1 = require("../baseChart/BaseChartDescriptor");
var sdk_model_1 = require("@gooddata/sdk-model");
var drillDownUtil_1 = require("../drillDownUtil");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var util_1 = require("@gooddata/util");
var ImplicitDrillDownHelper_1 = require("../../../utils/ImplicitDrillDownHelper");
var BarChartDescriptor = /** @class */ (function (_super) {
    tslib_1.__extends(BarChartDescriptor, _super);
    function BarChartDescriptor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BarChartDescriptor.prototype.getFactory = function () {
        return function (params) { return new PluggableBarChart_1.PluggableBarChart(params); };
    };
    BarChartDescriptor.prototype.applyDrillDown = function (source, drillDownContext) {
        var withFilters = this.addFiltersForColumnBar(source, drillDownContext.drillDefinition, drillDownContext.event);
        return drillDownUtil_1.modifyBucketsAttributesForDrillDown(withFilters, drillDownContext.drillDefinition);
    };
    BarChartDescriptor.prototype.adjustIntersectionForColumnBar = function (source, event) {
        var stackBucket = sdk_model_1.insightBucket(source, sdk_ui_1.BucketNames.STACK);
        var hasStackByAttributes = stackBucket && !sdk_model_1.bucketIsEmpty(stackBucket);
        var intersection = event.drillContext.intersection;
        return hasStackByAttributes ? util_1.arrayUtils.shiftArrayRight(intersection) : intersection;
    };
    BarChartDescriptor.prototype.addFiltersForColumnBar = function (source, drillConfig, event) {
        var clicked = ImplicitDrillDownHelper_1.drillDownFromAttributeLocalId(drillConfig);
        var reorderedIntersection = this.adjustIntersectionForColumnBar(source, event);
        var cutIntersection = sdk_ui_1.getIntersectionPartAfter(reorderedIntersection, clicked);
        return drillDownUtil_1.addIntersectionFiltersToInsight(source, cutIntersection);
    };
    return BarChartDescriptor;
}(BaseChartDescriptor_1.BaseChartDescriptor));
exports.BarChartDescriptor = BarChartDescriptor;
//# sourceMappingURL=BarChartDescriptor.js.map